const logLevels = {
    TRACE: {
        id: 0,
        name: 'TRACE',
    },
    DEBUG: {
        id: 1,
        name: 'DEBUG',
    },
    INFO: {
        id: 2,
        name: 'INFO',
    },
    WARN: {
        id: 3,
        name: 'WARN',
    },
    ERROR: {
        id: 4,
        name: 'ERROR',
    },
    FATAL: {
        id: 5,
        name: 'FATAL',
    },
    SILENT: {
        id: 6,
        name: 'SILENT',
    },
};

export default logLevels;
